module.exports = __webpack_public_path__ + "media/stable/components/site/place_hero/assets/eater-3384a6e625c156530c3eb33fe449f799.jpg";